<template>
  <v-panel>
    <v-form ref="form" v-model="valid">
      <div class="divider">
        <span>
          <b>Dados Básicos</b>
        </span>
      </div>
      <v-flex xs6 sm6 md6>
        <v-text-field
          name="farm"
          background-color="white"
          label="Propriedade"
          box
          v-model="formulario.farm"
        ></v-text-field>
      </v-flex>

      <v-flex xs6 sm6 md6>
        <v-text-field
          name="size"
          type="number"
          background-color="white"
          label="Tamanho da Propriedade (ha)"
          box
          v-model="formulario.size"
        ></v-text-field>
      </v-flex>

      <v-flex xs6 sm6 md6>
        <v-autocomplete
        :items="states()"
        @change="clearCity()"
        append-icon="map"
        label="Estado"
        no-data-text="Nenhum resultado"
        v-model="formulario.state"
        name="state"
        ></v-autocomplete>
      </v-flex>

      <v-flex xs6 sm6 md6>
        <v-autocomplete
        :items="cities"
        append-icon="location_on"
        label="Município"
        no-data-text="Nenhum resultado"
        v-model="formulario.city"
        name="city"
        ></v-autocomplete>
      </v-flex>

      {{form}}
    </v-form>
  </v-panel>
</template>
<script>
/* eslint-disable */
import DadosIniciais from "../../class/DadosIniciais.js";
import brazil from '../../assets/brazil.json'
export default {
  inject: ["$validator"],
  data: () => ({
    formulario: new DadosIniciais(),
    panel: [],
    lazy: true,
    valid: false,
    simulation: '',
    rules: {
      state: [
          v => (v && v.trim().length > 0) || 'Selecione o estado em que a propriedade está localizada!'
        ],
      city: [
        v => (v && v.trim().length > 0) || 'Selecione a cidade em que a propriedade está localizada!'
      ],
    }
  }),
  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  methods: {
    clear() {
      this.formulario = {
        formulario: Object.assign(this.$data, this.$options.data.apply())
      };
      this.$validator.reset();
    },
    states () {
      return brazil.states.map(function (e) {
        return e.name
      })
    },
    clearCity () {
      this.simulation.city = ''
    },
  },
  computed: {
    form: function() {
      this.$db.simulation.get({ code: this.simulation.code }, dado => {
        this.formulario = new DadosIniciais(dado.dadosIniciais);
      });
    },
    cities: function () {
      for (var i = 0; i < brazil.states.length; i++) {
        if (brazil.states[i].name === this.formulario.state) {
          return brazil.states[i].cities
        }
      }

      return []
    }
    
  }
};
</script>
<style scoped>
h2 {
  color: #00695c;
}

.botaoNone {
  border: solid black 1px;
  position: fixed;
  margin-bottom: 0;
  z-index: 997;
  bottom: 45px;
  right: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

@media screen and (max-width: 991px) {
  h2 {
    color: #00695c;
  }
  .container {
    position: relative;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }

  .panel {
    margin-top: 1%;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 15px black;
  }
  .form {
    margin-top: 2%;

    min-width: 100%;
  }
  .text-field {
    background-color: blue;
    font-size: 2px;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }
  .button {
    float: right;
  }
  .divider {
    text-align: center;
    font-size: 130%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    margin-top: 5%;
    margin-left: 5%;
    font-size: 110%;
  }
}

@media screen and (min-width: 992px) {
  h2 {
    color: #00695c;
  }
  .container {
    margin-top: 2%;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }
  .panel {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 10px black;
  }
  .panelGrafico {
    width: 70%;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }

  .button {
    float: right;
  }

  .divider {
    text-align: center;
    font-size: 180%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    font-size: 150%;
    margin-top: 5%;
    margin-left: 5%;
  }
  .layout {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>